import React, { Component } from "react";
import ReactDOM from "react-dom";

class Footer extends Component {
  render() {
    const currentYear = new Date().getFullYear();

    return (
      <>
        <footer>
          <div className="f-top">
            Copyright &copy; {currentYear} PT. Triyakom. All Rights Reserved
          </div>
          <div className="f-middle">
            Ikuti social media kami untuk mendapatkan promo dan info menarik
            lainnya.
          </div>
          <div className="f-bottom">
            <a href="https://www.facebook.com/funseleb.id">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                <g>
                  <path d="M28,0H4A4,4,0,0,0,0,4V28a4,4,0,0,0,4,4H16V21H12V16h4V12a6,6,0,0,1,6-6h4v5H24c-1.1,0-2-.1-2,1v4h5l-2,5H22V32h6a4,4,0,0,0,4-4V4A4,4,0,0,0,28,0Z" />
                </g>
              </svg>
            </a>
            <a href="https://www.instagram.com/funseleb_id/">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                <g>
                  <g>
                    <path
                      d="M22,0H10A10,10,0,0,0,0,10V22A10,10,0,0,0,10,32H22A10,10,0,0,0,32,22V10A10,10,0,0,0,22,0Zm7,22a7.008,7.008,0,0,1-7,7H10a7.008,7.008,0,0,1-7-7V10a7.008,7.008,0,0,1,7-7H22a7.008,7.008,0,0,1,7,7Z"
                      fill="#082427"
                    />
                  </g>
                </g>
                <g transform="translate(8 8)">
                  <g>
                    <path
                      d="M136,128a8,8,0,1,0,8,8A8,8,0,0,0,136,128Zm0,13a5,5,0,1,1,5-5A5.007,5.007,0,0,1,136,141Z"
                      transform="translate(-128 -128)"
                    />
                  </g>
                </g>
                <g transform="translate(23.534 6.334)">
                  <g>
                    <ellipse
                      className="c"
                      cx="1.066"
                      cy="1.066"
                      rx="1.066"
                      ry="1.066"
                    />
                  </g>
                </g>
              </svg>
            </a>
            <a href="https://www.youtube.com/channel/UCfduRkTqIFPJWvNuZZXlUOw/">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46.545 32">
                <g transform="translate(0 0)">
                  <path
                    d="M44.567,83.084c-1.263-2.246-2.633-2.659-5.423-2.816C36.358,80.079,29.35,80,23.279,80s-13.094.079-15.878.265c-2.784.16-4.157.57-5.431,2.819C.669,85.327,0,89.19,0,95.991v.023c0,6.772.669,10.665,1.969,12.884,1.274,2.246,2.644,2.653,5.428,2.842,2.787.163,9.8.259,15.881.259s13.079-.1,15.869-.256c2.79-.189,4.16-.6,5.423-2.842,1.312-2.22,1.975-6.112,1.975-12.884v-.023C46.546,89.19,45.882,85.327,44.567,83.084ZM17.455,104.727V87.273L32,96Z"
                    transform="translate(0 -80)"
                  />
                </g>
              </svg>
            </a>
            <a href="https://tykm.me/CS">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32.4"
                height="32.502"
                viewBox="0 0 32.4 32.502"
              >
                <g
                  id="Group_573"
                  data-name="Group 573"
                  transform="translate(-6.587 -6.355)"
                >
                  <g
                    id="Group_574"
                    data-name="Group 574"
                    transform="translate(6.787 6.555)"
                  >
                    <path
                      id="Path_983"
                      data-name="Path 983"
                      d="M46.695,61.649a15.927,15.927,0,0,1-7.98-2.148l-6.234,2.148,1.281-6.6a15.815,15.815,0,0,1-3.067-9.4,16,16,0,1,1,16,16M39,56.884l.482.3a13.64,13.64,0,1,0-3.515-3.166l.334.427-.7,3.607Z"
                      transform="translate(-30.695 -29.649)"
                      fill="#fff"
                      stroke="#fff"
                      stroke-width="0.4"
                    />
                    <path
                      id="Path_984"
                      data-name="Path 984"
                      d="M53.508,55.654s.938-1.641,1.7-1.735,1.751-.094,2.016.406,1.454,3.408,1.454,3.408a1.144,1.144,0,0,1-.11.984,9.7,9.7,0,0,1-1.015,1.188.868.868,0,0,0,0,1.031A18.789,18.789,0,0,0,59.808,63.7a12.274,12.274,0,0,0,3.657,2.147.732.732,0,0,0,.563-.173c.219-.219,1.407-1.7,1.407-1.7a.835.835,0,0,1,1.016-.2c.632.289,3.375,1.656,3.375,1.656a.594.594,0,0,1,.321.6,3.868,3.868,0,0,1-.6,2.071,4.775,4.775,0,0,1-3.334,1.636,14.713,14.713,0,0,1-8.19-3.668c-2.235-2.236-4.22-4.5-4.688-6.565s-.407-3,.172-3.845"
                      transform="translate(-45.586 -45.802)"
                      fill="#fff"
                    />
                  </g>
                </g>
              </svg>
            </a>
          </div>
        </footer>
      </>
    );
  }
}

export default Footer;
